import React from 'react';
import styles from './Paginator.module.scss';
import leftArrow from '../../../../../assets/icons/vector/leftArrow.svg';
import rightArrow from '../../../../../assets/icons/vector/rightArrow.svg';
import { useBrandingContext } from 'app-context/BrandingsContext';

const Paginator = ({ currentPage, totalPages, onPageChange }) => {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const generatePageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(1);

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) {
      pages.push('...');
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push('...');
    }

    pages.push(totalPages);

    return pages;
  };

  const pages = generatePageNumbers();

  return (
    <div className={styles['paginator-container']}>
      <button
        className={`${styles['page-arrow']} ${
          currentPage === 1 ? styles['disabled'] : ''
        }`}
        disabled={currentPage === 1}
        onClick={() => handlePageClick(currentPage - 1)}
        style={{
          backgroundColor: currentPage === 1 ? '#9ca3af' : page_ButtonColor,
          borderColor: currentPage === 1 ? '#9ca3af' : page_ButtonColor,
        }}
      >
        <img alt='Left Arrow' src={leftArrow} />
      </button>

      <div className={styles.paginator}>
        {pages.map((page, index) =>
          typeof page === 'number' ? (
            <div
              key={`${page}-${index}`}
              className={`${styles['page-item']} ${
                page === currentPage ? styles['active'] : ''
              }`}
              style={{
                ...(page === currentPage
                  ? {
                      backgroundColor: page_ButtonColor,
                      borderColor: page_ButtonColor,
                      border: `1px solid ${page_ButtonColor}`,
                    }
                  : {
                      border: `1px solid ${page_ButtonColor}`,
                    }),
                ...(String(page).length > 3
                  ? { minWidth: `${String(page).length + 1.5}ch` }
                  : {}),
              }}
              onClick={() => handlePageClick(page)}
            >
              {page}
            </div>
          ) : (
            <div key={`ell-${index}`} className={styles.ellipsis}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )
        )}
      </div>

      <button
        className={`${styles['page-arrow']} ${
          currentPage === totalPages ? styles['disabled'] : ''
        }`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageClick(currentPage + 1)}
        style={{
          backgroundColor:
            currentPage === totalPages ? '#9ca3af' : page_ButtonColor,
          borderColor:
            currentPage === totalPages ? '#9ca3af' : page_ButtonColor,
        }}
      >
        <img className={styles.arrows} alt='Right Arrow' src={rightArrow} />
      </button>
    </div>
  );
};

export default Paginator;
